<div class="download-app-see-more">
  <p mipTranslate="download-app-see-more.message" [translateValues]="{finalLabel: finalLabel}">
    To see more <strong>{{finalLabel}}</strong>, please download the APP:
  </p>
  <mip-download-app-buttons></mip-download-app-buttons>
</div>
